// src/components/GuestRoute.jsx

import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";

function GuestRoute({ element }) {
  const { user, status } = useSelector((state) => state.user);

  // If user is still loading or undefined, show loading state
  if (status === "loading" || user === undefined) {
    return <LoadingSpinner message="Loading..." />;
  }

  // If user is logged in, redirect them to /rooms
  if (user) {
    return <Navigate to="/rooms" replace />;
  }

  // If user is not logged in (null), render the given element (login, register, etc.)
  return element;
}

export default GuestRoute;